import awardsImg from "../../../assets/awards.jpg"
import { getArray } from "../../../utils/helpers";

const Awards = ({t}) => {
    const { awards = {} } = t
    return (
        <section className="py-12 bg-white mx-auto">
            <div className="container mx-auto px-4 max-w-[1200px]">
                <div className="flex flex-wrap -mx-4">
                    {/* Left Column */}
                    <div className="w-full lg:w-1/2 px-4 mb-12 lg:mb-0">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{awards?.title}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{awards?.subTitle}</h2>
                        
                        <ul className="space-y-4 mb-8">
                            {getArray(awards?.lists).map((item, index) => (
                                <li key={index} className="flex items-start">
                                    <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                    <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* Right Column */}
                    <div className="w-full lg:w-1/2 px-4">
                        <img 
                            src={awardsImg}
                            alt="Chef Luca Fantin"
                            width={600}
                            height={650}
                            className="w-full h-[650px] object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Awards;